import React, { useCallback, useEffect } from 'react';
import { EnterCredential } from 'new/elements/flows/EnterCredential';
import { eventTypes, FCFormPageType, useForm } from 'new/elements/Form/useForm';
import useCredentialsPage from 'new/components/flows/controller/useCredentialsPage';
import { loadDataCredentials } from 'js/actions';
import { ACLQueryModeTypes } from 'js/constants/visibilityFilters';
import useAppDispatch from 'js/hooks/useAppDispatch';
import { FORM_TYPE_CREATE_RERANKER_FLOW } from 'js/constants/formTypes';
import useReranker from 'new/elements/flows/ModalConfigureReranker/useReranker';
import {
  ADD_DATASET_REQUEST,
  CREATE_CODE_CONTAINER_REQUEST,
  UPDATE_DATASET_REQUEST,
} from 'js/constants/actionTypes';
import useConfigReranker from 'new/elements/flows/ModalConfigureReranker/steps/ConfigStep/useConfigReranker';
import { render } from '@testing-library/react';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_ALL_CREDENTIALS_REQUEST } from 'js/constants/actionTypes';

export const EnterCredentialStep: FCFormPageType<any> = ({
  editingNexset,
  parentNexset,
  onClose,
}) => {
  const { credentialId, selectedConnection, selectedCredentialInfo } = useReranker();
  const dispatch = useAppDispatch();
  const {
    onSaveCredential,
    onChangeTemplate,
    selectedTemplate,
    onEditCredential,
    onCredentialSelected,
    onCredentialInfoUpdated,
  } = useCredentialsPage({
    useFormData: useReranker,
    formType: FORM_TYPE_CREATE_RERANKER_FLOW,
  });
  const { overrideNextFunction, setLoaderMessages } = useForm();
  const save = useConfigReranker({ parentNexset, editingNexset });

  const loadCredentialNeeds = () => {
    dispatch(loadDataCredentials(ACLQueryModeTypes.MODE_COLLABORATOR.key));
  };

  const areCredentialsLoading = useIsLoading(GET_ALL_CREDENTIALS_REQUEST);

  const onNext = useCallback(async () => {
    const reranker = await save();
    if (reranker) {
      onClose();
      return true;
    }
    return false;
  }, [save]);

  overrideNextFunction(onNext);
  useEffect(() => {
    setLoaderMessages({
      [CREATE_CODE_CONTAINER_REQUEST]: 'Creating container',
      [UPDATE_DATASET_REQUEST]: 'Updating reranker',
      [ADD_DATASET_REQUEST]: 'Creating reranker',
    });
  }, []);

  return (
    <EnterCredential
      reload={loadCredentialNeeds}
      areCredentialsLoading={areCredentialsLoading}
      credentialId={credentialId}
      onChangeTemplate={onChangeTemplate}
      selectedTemplate={selectedTemplate}
      onCredentialInfoUpdated={onCredentialInfoUpdated}
      onSaveCredential={onSaveCredential}
      onEditCredential={onEditCredential}
      selectedCredentialInfo={selectedCredentialInfo}
      onCredentialSelected={onCredentialSelected}
      connectionType={selectedConnection}
    />
  );
};

EnterCredentialStep.formConfig = {
  title: 'Authenticate',
};
